import {
  components,
} from '@/generated/qmulus/openapi.ts';

export enum EAppPermission {
  READ = 'Read',
  WRITE = 'Write',
}

export const appPermission: Record<components['schemas']['Permission'], keyof typeof EAppPermission> = {
  Read: 'READ',
  Write: 'WRITE',
};
